import { computed, ComputedRef, Ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { DocumentParameter } from '@vue/apollo-composable/dist/useQuery'

export type RecruiterListVariables = {
  accounts: string[]
  page: number
  perPage: number
  search: string | null
  statuses?: string[]
  tags?: string[]
  markets?: string[]
  orderBy: Object[]
}

export type RecruiterListEntryRecruiter = {
  id: string
  name: string | null
  avatar: string | null
  market: string
}

export type RecruiterListEntry = {
  id: string
  email: string
  recruiterId: string
  recruiter: RecruiterListEntryRecruiter
  recruiterFee: number
  recruiterOwnershipDays: number
  recruiterOwnershipDaysLeft: number
  status: string
  tags: Array<any>
}

export default function useRecruitersList(
  query: DocumentParameter<any, RecruiterListVariables>,
  variables: Ref<RecruiterListVariables>,
) {
  const { result, loading, refetch } = useQuery(query, variables, {
    clientId: 'publicApi',
  })

  const parsedResult: ComputedRef<RecruiterListEntry[]> = computed(
    () =>
      result.value?.companyRecruiters.data.map((entry) => ({
        id: entry.id,
        recruiterId: entry.recruiter.id,
        market: entry.recruiter.market,
        initials: entry.recruiter.initials,
        email: entry.email,
        name: entry.recruiter.name,
        avatar: entry.recruiter.avatar,
        recruiterFee: entry.recruiterFee,
        recruiterOwnershipDays: entry.recruiterOwnershipDays,
        recruiterOwnershipDaysLeft: entry.recruiterOwnershipDaysLeft,
        status: entry.status.toLowerCase(),
        tags: entry.tags,
      })) ?? [],
  )

  return {
    recruiters: parsedResult,
    rawResult: result,
    loading,
    refetch,
  }
}
